import { BaseClient } from '@/api'

export class WinClientClient extends BaseClient {
  constructor(
  ) {
    super('clients')
  }
}
